import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Typography
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Container, HeadingText, InnerContainer, Text } from './FAQs.style';
export const FAQs = () => {
  return (
    <Container>
      <InnerContainer>
        <HeadingText>Frequently Asked Questions</HeadingText>
        <div>
          <Accordion>
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1a-content"
              id="panel1a-header"
            >
              <Text>Which networks are supported for accepting payments?</Text>
            </AccordionSummary>
            <AccordionDetails>
              <Typography>
                we support Flow, Solana, Polygon, Avalanche, BSC and Fantom. We
                are also planning to extend support to Arbitrum, Optimism, NEAR,
                etc in near future.
              </Typography>
            </AccordionDetails>
          </Accordion>
          <Accordion>
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel2a-content"
              id="panel2a-header"
            >
              <Text>Are Stable Coins supported?</Text>
            </AccordionSummary>
            <AccordionDetails>
              <Typography>
                Yes, we support all the major stablecoins like USDC, USDT, DAI,
                MIM, BUSD on most of the networks.
              </Typography>
            </AccordionDetails>
          </Accordion>
          <Accordion>
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel2a-content"
              id="panel2a-header"
            >
              <Text>How much is the fees for using RoundPe?</Text>
            </AccordionSummary>
            <AccordionDetails>
              <Typography>
                We charge only 1% fees on transactions. There is no
                setup/integration fees or monthly maintanance fees. The 1% fees
                can be reduced for higher volumes. Contact us at
                partnerships@roundpe.com for further discussion.
              </Typography>
            </AccordionDetails>
          </Accordion>
          <Accordion>
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel2a-content"
              id="panel2a-header"
            >
              <Text>
                Which wallet are supported for completing a payment via RoundPe?
              </Text>
            </AccordionSummary>
            <AccordionDetails>
              <Typography>
                Users can pay from anywhere - Metamask, Binance account,
                Coinbase account, mobile wallets, ledger - All kind of wallets
                are supported. Users get an address and amount, which they can
                send from anywhere to complete the payment.
              </Typography>
            </AccordionDetails>
          </Accordion>
          <Accordion>
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel2a-content"
              id="panel2a-header"
            >
              <Text>Can I create invoices with RoundPe?</Text>
            </AccordionSummary>
            <AccordionDetails>
              <Typography>
                Yes, you can easily create invoices to accept payments using
                RoundPe. You can also upload a pdf for providing extra
                information to the user.
              </Typography>
            </AccordionDetails>
          </Accordion>
        </div>
      </InnerContainer>
    </Container>
  );
};
